import { LinearProgressProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'ProgressBar';

export type Color = Exclude<LinearProgressProps['color'], 'inherit'>;

export const useProgressBarStyles = makeStyles<Color>({ name })(
  (theme, color) => ({
    progressLabels: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
    },
    labelText: {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
    linearProgress: {
      height: 6,

      borderRadius: 2,

      backgroundColor: color ? theme.palette[color].light : undefined,
    },
  }),
);
